module.exports = __webpack_public_path__ + "static/media/home_bg_wide.2eaebf1e.png";